import { useController } from 'react-hook-form';
import { InputGroup, NumberInput, Whisper, Tooltip } from 'rsuite';
import { icons } from '@shared/static/icons';
import { FormGroup } from '@shared/ui/forms/display';
import { currencySymbols } from '@utils/static';
import { validateMaxAmount } from '@utils/validation';

export default function AmountInput({
  control,
  name,
  label,
  hint,
  placeholder,
  currency,
  onChange,
  isRequired = false,
  error,
  min,
  max,
  disabled = false,
  validation,
  integer = false,
  tooltip,
}) {
  const { field } = useController({
    control,
    name,
    rules: {
      required: isRequired,
      validate: (value) => {
        const maxResult = validateMaxAmount(value, max);
        if (maxResult !== true) return maxResult;
        return validation ? validation(value, min) : true;
      },
    },
  });

  return (
    <FormGroup label={label} hint={hint} error={error}>
      <InputGroup inside className={field.value ? 'has-value' : ''}>
        <NumberInput
          value={field.value}
          onChange={(value) => {
            if (integer && !/^\d*$/.test(value)) return;
            field.onChange(value);
            onChange?.(value);
          }}
          placeholder={placeholder}
          suffix={currency ? currencySymbols[currency] : ''}
          min={min}
          max={max}
          disabled={disabled}
        />
        {tooltip && (
          <InputGroup.Addon>
            <Whisper
              placement="auto"
              controlId="control-id-hover"
              trigger="hover"
              speaker={<Tooltip>{tooltip}</Tooltip>}
            >
              <button className="d-flex">{icons.hint}</button>
            </Whisper>
          </InputGroup.Addon>
        )}
      </InputGroup>
    </FormGroup>
  );
}
